import { createServerFn } from "@tanstack/react-start";
import { getContentItemByPath20 } from "#/_generated/umbraco/delivery-api/features/content/content.ts";
import { getUmbracoDeliveryApiV2ContentFeedContentId } from "#/_generated/umbraco/delivery-api/features/custom/custom.ts";
import type {
	GetUmbracoDeliveryApiV2ContentFeedContentIdParams,
	IApiContentResponseModel,
} from "#/_generated/umbraco/delivery-api/models";

const getContentItemByPathServer = createServerFn({
	method: "GET",
	strict: { output: false },
})
	.validator((data: { path: string }) => data)
	.handler(async ({ data }) => {
		const response = await getContentItemByPath20({}, data.path);

		return {
			data: response.data,
			status: response.status,
		};
	});

export async function getContentItemByPath<T = IApiContentResponseModel>(data: {
	path: string;
}): Promise<{
	data: T;
	status: number;
}> {
	const response = await getContentItemByPathServer({ data });

	return {
		data: response.data as T,
		status: response.status,
	};
}

export const getContentFeedContentById = createServerFn({
	method: "GET",
	strict: { output: false },
})
	.validator(
		(data: {
			id: string;
			params: GetUmbracoDeliveryApiV2ContentFeedContentIdParams;
		}) => data,
	)
	.handler(async ({ data }) => {
		const response = await getUmbracoDeliveryApiV2ContentFeedContentId(
			data.id,
			data.params,
		);

		return {
			data: response.data,
			status: response.status,
		};
	});
